import { useMemo } from 'react';
import usaStates from '../utilities/usaStates.json';

export default function useUsStates(): { label: string; value: string }[] {
  const usStates = useMemo(() => {
    return usaStates.map((s) => ({ label: s.name, value: s.abbreviation }));
  }, []);
  return usStates;
}
